import { GoogleLogin } from '@react-oauth/google'
import { useNavigate } from 'react-router-dom'
import { useGoogleAuth } from '@/hooks/auth/useGoogleAuth'

interface GoogleAuthSectionProps {
  mode: 'signin' | 'signup'
  /** Called with a message on failure, and with '' when a new attempt starts. */
  onError: (message: string) => void
}

/** "or" divider + Google button; renders nothing when Google auth isn't configured. */
export function GoogleAuthSection({ mode, onError }: GoogleAuthSectionProps) {
  const navigate = useNavigate()
  const googleAuth = useGoogleAuth()

  if (!import.meta.env.VITE_GOOGLE_CLIENT_ID) return null

  const failureMessage = mode === 'signin' ? 'Google sign-in failed' : 'Google sign-up failed'

  const handleSuccess = async (response: { credential?: string }) => {
    if (!response.credential) return
    onError('')
    try {
      await googleAuth.mutateAsync(response.credential)
      navigate('/')
    } catch (err) {
      onError(err instanceof Error ? err.message : failureMessage)
    }
  }

  return (
    <>
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-surface px-2 text-muted">or</span>
        </div>
      </div>

      <div className="flex justify-center">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => onError(failureMessage)}
          text={mode === 'signin' ? 'signin_with' : 'signup_with'}
          theme="filled_black"
          size="large"
          width="300"
          use_fedcm_for_prompt={false}
        />
      </div>
    </>
  )
}
